module.exports = __webpack_public_path__ + "static/media/box-icon-w.dadf0a3b.svg";